import { render } from "./AdminReportsUsageBreakdown.vue?vue&type=template&id=8ecb45ce&ts=true"
import script from "./AdminReportsUsageBreakdown.vue?vue&type=script&lang=ts"
export * from "./AdminReportsUsageBreakdown.vue?vue&type=script&lang=ts"

import "./AdminReportsUsageBreakdown.vue?vue&type=style&index=0&id=8ecb45ce&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.38_typescript@5.9.3__webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__